import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from "vue-property-decorator";
export default class ConfirmDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "closeOnOutsideClick", void 0);
    _defineProperty(this, "showClose", void 0);
    _defineProperty(this, "cancelBtnTitle", void 0);
    _defineProperty(this, "confirmBtnTitle", void 0);
    _defineProperty(this, "isDeleteAction", void 0);
    _defineProperty(this, "isVisible", false);
  }
  mounted() {
    this.isVisible = this.visible;
  }
  onVisiblePropChanges() {
    this.isVisible = this.visible;
  }
  handleDialogClose() {
    this.isVisible = false;
    return true;
  }
  handleConfirmAction() {
    this.isVisible = false;
    return true;
  }
}
__decorate([Prop({
  default: false
})], ConfirmDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "title", void 0);
__decorate([Prop({
  default: '560px'
})], ConfirmDialog.prototype, "width", void 0);
__decorate([Prop({
  default: true
})], ConfirmDialog.prototype, "closeOnOutsideClick", void 0);
__decorate([Prop({
  default: true
})], ConfirmDialog.prototype, "showClose", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "cancelBtnTitle", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "confirmBtnTitle", void 0);
__decorate([Prop({
  default: false
})], ConfirmDialog.prototype, "isDeleteAction", void 0);
__decorate([Watch('visible')], ConfirmDialog.prototype, "onVisiblePropChanges", null);
__decorate([Emit("dialog-close")], ConfirmDialog.prototype, "handleDialogClose", null);
__decorate([Emit("on-confirmed")], ConfirmDialog.prototype, "handleConfirmAction", null);